import { render } from "./UserWeb.vue?vue&type=template&id=187407fc"
import script from "./UserWeb.vue?vue&type=script&lang=js"
export * from "./UserWeb.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\DEVAREA\\OFFICE\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__